import List from '../../../../components/People/Timesheet/Lines/List'
import TimesheetLinesModal from '../../../../components/People/Timesheet/Lines/TimesheetLinesModal'
import React, { Fragment } from 'react'

function TimesheetLines(props) {
  return (
    <Fragment>
      <TimesheetLinesModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

export default TimesheetLines
